"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSlotsList = void 0;
const api_1 = require("../../../../lib/api");
const Events_1 = require("../../../lib/constants/Events");
const apptTime_utils_1 = require("./apptTime.utils");
const getSlotsList = '@service/getSlotsList';
exports.getSlotsList = getSlotsList;
const services = {
    [getSlotsList]: (ctx, ev) => {
        const { customerCode, productName, apiBaseURL } = ctx;
        const api = new api_1.Api({
            customerCode,
            productName,
            apiBaseURL
        });
        /** if deepLinking or jumpToDate,
         *  call /scheduling/list directly with ctx.query.periodStart as start_datetime */
        if (ctx.query.periodStart && ev.type !== Events_1.LOAD_MORE) {
            return api.getScheduling((0, apptTime_utils_1.schedulingParamsFromCtx)(ctx, ev));
        }
        /** if loading the page from the previous step or loading more results,
         *  call /availability/next then use next availability start_datetime to call /scheduling/list */
        return api.getNextSchedulingList({
            params: (0, apptTime_utils_1.schedulingParamsFromCtx)(ctx, ev),
            isInitialLoad: ctx.isInitialDataLoadFromPreviousStep
        });
    }
};
exports.default = services;
//# sourceMappingURL=services.apptTime.js.map